import { App } from "antd";
import { useCallback } from "react";
import { ProgressBar } from "../../components/ProgressBar";
import BackGroundService from "../../services/background";

export const useOpenProgressModal = (
  title: string,
  errorMessage: string,
  onSuccess: (id?: string) => void,
  message?: {
    customMsg?: string;
    closable?: boolean;
  },
  onError?: () => void,
  options?: {
    errorMessageClosable?: boolean;
  }
) => {
  const { modal } = App.useApp();

  const openModal = useCallback(
    (id: string) => {
      modal.confirm({
        title,
        icon: null,
        okButtonProps: {
          style: { display: "none" }
        },
        cancelButtonProps: {
          shape: "round"
        },
        content: (
          <ProgressBar
            id={id}
            onSuccess={onSuccess}
            errorMessage={errorMessage}
            message={message}
            onError={onError}
            options={options}
          />
        ),
        onCancel: async () => await BackGroundService.cancelTask(id)
      });
    },
    [modal, title, onSuccess, errorMessage, message, onError, options]
  );

  return { openModal };
};
